<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
    <span>
      <el-radio-group class="mr-r10" v-model="dataType">
        <el-radio :label="dataTypeData.connect" @change="onDataTypeChange">접속 상태</el-radio>
        <el-radio :label="dataTypeData.account" @change="onDataTypeChange">계정 전환</el-radio>
        <el-radio :label="dataTypeData.password" @change="onDataTypeChange">암호 변경</el-radio>
        <el-radio :label="dataTypeData.portCtrl" @change="onDataTypeChange">차단 상태</el-radio>
      </el-radio-group>
      <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
    </span>
  </el-row>
  <el-row>
    <!-- 접속 이력 -->
    <el-table-wrapper v-show="dataType === dataTypeData.connect" ref="connectionTable" v-loading="loading.connect" :data="tableData.connect" :columns="columns.connect" :pagination="true" :column-default="columnDefault" :show-custom-header="true"
      :show-search-tool="showSearchTool.connect" :show-overflow-tooltip="true" :total="total.connect" :remote="true" @condition-change="loadData">
    </el-table-wrapper>
    <!-- 계정 전환 -->
    <el-table-wrapper v-show="dataType === dataTypeData.account" ref="accountTable" v-loading="loading.account" :data="tableData.account" :columns="columns.account" :pagination="true" :column-default="columnDefault" :show-custom-header="true"
      :show-search-tool="showSearchTool.account" :show-overflow-tooltip="true" :total="total.account" :remote="true" @condition-change="loadData">
    </el-table-wrapper>
    <!-- 암호 변경 -->
    <el-table-wrapper v-show="dataType === dataTypeData.password" ref="passwordTable" v-loading="loading.password" :data="tableData.password" :columns="columns.password" :pagination="true" :column-default="columnDefault" :show-custom-header="true"
      :show-search-tool="showSearchTool.password" :show-overflow-tooltip="true" :total="total.password" :remote="true" @condition-change="loadData">
    </el-table-wrapper>
    <!-- 차단 이력 -->
    <el-table-wrapper v-show="dataType === dataTypeData.portCtrl" ref="portCtrlTable" v-loading="loading.portCtrl" :data="tableData.portCtrl" :columns="columns.portCtrl" :pagination="true" :column-default="columnDefault" :show-custom-header="true"
      :show-search-tool="showSearchTool.portCtrl" :show-overflow-tooltip="true" :total="total.portCtrl" :remote="true" @condition-change="loadData">
    </el-table-wrapper>
    <!-- 구성 > 파일 정보 > 파일 접근 이력 추가됨
    <el-table-wrapper v-show="statuskey === 'FILE_ACCESS' && selectedNode.obj.objtypeId != 'WINSVR'" :pagination="true" :data="tableData" :column-default="columnDefault" :columns="column['FILE_ACCESS']" :show-custom-header="true" :show-search-tool="showfileAccessSearchTool"
    style="width:100%;" :show-overflow-tooltip="true" ref="fileTable" :total="SystemTotal" :remote="true" @condition-change="onChangeTable">
  </el-table-wrapper> -->
  </el-row>
</div>
</template>
<script>
import moment from 'moment';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDuration } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import msgUtil from '@/utils/message';
import serverTableInfoAPI from '@/api/performance/server/info-table';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import { mapGetters } from 'vuex';

export default {
  name: 'WSystemAccessInfoTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      columnDefault,
      dataTypeData: {
        connect: 'CONNECTION_HIST',
        account: 'ACCOUNT_SWITCH',
        password: 'PASSWORD_MODIFY',
        portCtrl: 'PORTCTRL_HIST',
      },
      dataType: 'CONNECTION_HIST',
      showSearchTool: {
        connect: false,
        account: false,
        password: false,
        portCtrl: false,
      },
      loading: {
        connect: false,
        account: false,
        password: false,
        portCtrl: false,
      },
      tableData: {
        connect: [],
        account: [],
        password: [],
        portCtrl: [],
      },
      total: {
        connect: 0,
        account: 0,
        password: 0,
        portCtrl: 0,
      },
      checkDatetime: null,
      baseDatetime: null,
      connectColumns: {
        CONN_HIST_COLUMNS: [
          {
            prop: 'userName',
            label: '사용자명',
            remoteProp: 'sys.userName',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: '접속IP',
            remoteProp: 'sys.ipaddress',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ttyName',
            label: '터미널 명',
            remoteProp: 'sys.ttyName',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'startDatetime',
            label: '접속시작시각',
            remoteProp: 'sys.startDatetime',
            sortable: true,
            searchable: false,
            searchType: 'date',
            formatter: this.getTime,
          },
          {
            prop: 'endDatetime',
            label: '접속종료시각',
            remoteProp: 'sys.endDatetime',
            sortable: true,
            searchable: false,
            searchType: 'date',
            formatter: this.getTime,
          },
          {
            prop: 'durationTime',
            label: '접속유지시각',
            sortable: true,
            formatter: this.getDuration,
          },
        ],
        CONN_CURRENT_COLUMNS: [
          {
            prop: 'userName',
            label: '사용자명',
            remoteProp: 'sys.userName',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: '접속IP',
            remoteProp: 'ipaddress',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ttyName',
            label: '터미널 명',
            remoteProp: 'sys.ttyName',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'connectTime',
            label: '접속시각',
            remoteProp: 'sys.connectTime',
            sortable: true,
            searchable: false,
            formatter: this.getTime,
          },
        ],
      },
      columns: {
        connect: [],
        account: [
          {
            prop: 'ttyName',
            label: '터미널 명',
            remoteProp: 'slsh.tty_name',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: '접속IP',
            remoteProp: 'slsh.ipaddress',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'suInitUsername',
            label: '초기 접속 사용자',
            remoteProp: 'slsh.su_init_username',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'suCurUsername',
            label: '변경 접속 사용',
            remoteProp: 'slsh.su_cur_username',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'suFinalUsername',
            label: '최종 접속 사용자',
            remoteProp: 'slsh.su_final_username',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'checkDatetime',
            label: '총 작업 시간',
            remoteProp: 'slsh.check_datetime',
            sortable: true,
            showOverflowTooltip: true,
            searchable: true,
            formatter: this.getTime,
            searchType: 'date',
          },
        ],
        password: [
          {
            prop: 'loginId',
            label: '로그인 ID',
            remoteProp: 'slch.login_id',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ttyName',
            label: '단말기 이름',
            remoteProp: 'slch.tty_name',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'ipaddress',
            label: 'IP주소',
            remoteProp: 'slch.ipaddress',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'userName',
            label: '사용자 이름',
            remoteProp: 'slch.user_name',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'checkDatetime',
            label: '암호변경시각',
            remoteProp: 'slch.check_datetime',
            sortable: true,
            searchable: true,
            searchType: 'date',
            formatter: this.getTime,
          },
          {
            prop: 'passwordNew',
            label: '성공유무',
            remoteProp: 'slch.password_new',
            sortable: true,
            formatter: this.getSuccess,
            filterMultiple: false,
            filters: [
              {
                text: '성공',
                value: 'SS',
              },
              {
                text: '실패',
                value: 'FF',
              },
            ],
          },
        ],
        portCtrl: [
          {
            prop: 'ipaddress',
            label: 'IP주소',
            remoteProp: 'slph.ipaddress',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'macaddress',
            label: 'MAC주소',
            remoteProp: 'slph.macaddress',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'srcPort',
            label: 'SRC포트',
            remoteProp: 'slph.src_port',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'dstPort',
            label: 'DST포트',
            remoteProp: 'slph.dst_port',
            sortable: true,
            searchable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'checkDatetime',
            label: '차단시각',
            remoteProp: 'slph.check_datetime',
            sortable: true,
            searchable: true,
            searchType: 'date',
            formatter: this.getTime,
          },
        ],
        // file: [
        //   {
        //     prop: 'accessType',
        //     label: '접근 구분',
        //     formatter: this.formatterFileType,
        //     width: 120,
        //     filterMultiple: false,
        //     filters: [
        //       {
        //         text: '파일복사',
        //         value: 'CP',
        //       },
        //       {
        //         text: '파일이동',
        //         value: 'MV',
        //       },
        //       {
        //         text: '파일접근',
        //         value: 'OP',
        //       },
        //       {
        //         text: '파일삭제',
        //         value: 'RM',
        //       },
        //     ],
        //   },
        //   {
        //     prop: 'srcFile',
        //     label: '원본파일',
        //     searchable: true,
        //     formatter: this.formatterFileSrc,
        //   },
        //   {
        //     prop: 'dstFile',
        //     label: '대상파일',
        //     searchable: true,
        //     formatter: this.formatterFileDst,
        //   },
        //   {
        //     prop: 'fileCmd',
        //     label: '사용 명령어',
        //     searchable: true,
        //     width: 80,
        //     formatter: this.getTableValueAfterCheckEmpty,
        //   },
        //   {
        //     prop: 'userName',
        //     label: '사용자',
        //     searchable: true,
        //     width: 120,
        //     formatter: this.getTableValueAfterCheckEmpty,
        //   },
        //   {
        //     prop: 'ipaddress',
        //     label: '사용자 IP',
        //     searchable: true,
        //     width: 120,
        //     formatter: this.getTableValueAfterCheckEmpty,
        //   },
        //   {
        //     prop: 'checkDatetime',
        //     label: '접근시각',
        //     searchable: true,
        //     searchType: 'date',
        //     formatter: this.getTime,
        //     width: 150,
        //   },
        // ],
      },
    };
  },
  computed: {
    isWindow() {
      return !isEmpty(this.selectedNode) && this.selectedNode.obj.objtypeId === 'WINSVR';
    },
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    /**
     * 접속 이력일 경우에만 현재/이력 분기처리하여 columns을 바꾼다.
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     * @author jda
     */
    timeType: {
      immediate: true,
      handler(type) {
        if (this.dataType !== this.dataTypeData.connect) {
          return;
        }

        if (!isEmpty(this.columns.connect)) {
          this.$refs.connectionTable.clearFilter();
          this.columns.connect = [];
        }
        // 운영탭의 경우 '현재'로 조회하기 때문에 분기처리 추가
        this.$nextTick(() => {
          if (type === analysisTimeType.CURRENT.value || this.operationFlag) {
            this.columns.connect = this.connectColumns.CONN_CURRENT_COLUMNS;
          } else {
            this.columns.connect = this.connectColumns.CONN_HIST_COLUMNS;
          }
        });
      },
    },
  },
  methods: {
    loadData() {
      if (this.dataType === this.dataTypeData.connect) {
        this.$nextTick(() => {
          this.loadConnectionHistData();
        });
      } else if (this.dataType === this.dataTypeData.account) {
        if (this.$refs.accountTable) {
          this.loadAccountSwitchData();
        } else {
          this.$nextTick(() => {
            this.loadAccountSwitchData();
          });
        }
      } else if (this.dataType === this.dataTypeData.password) {
        if (this.$refs.passwordTable) {
          this.loadPasswordChangeData();
        } else {
          this.$nextTick(() => {
            this.loadPasswordChangeData();
          });
        }
      } else if (this.dataType === this.dataTypeData.portCtrl) {
        if (this.$refs.portCtrlTable) {
          this.loadPortCtrlData();
        } else {
          this.$nextTick(() => {
            this.loadPortCtrlData();
          });
        }
      }
    },
    /**
     * 접속 이력을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadConnectionHistData() {
      const tableParams = this.$refs.connectionTable.getParameter();
      let params = {
        ...tableParams,
      };

      let url;
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        // 현재 탭에서는 startDatetime, endDatetime 필요 X
        params.dateSearchParams = null;
        params.objId = this.selectedNode.obj.objId;
        url = 'getSystemConnCurList';
      } else {
        const commonParams = this.getCommonParams();
        params = {
          ...params,
          ...commonParams,
        };

        url = 'getLogSystemconnList';
      }
      this.loading.connect = true;
      serverTableInfoAPI[url](params)
        .then((response) => {
          if (response.data.success === true) {
            this.tableData.connect = response.data.data;
            this.total.connect = response.data.total;
            this.checkDatetime = this.baseDatetime;
          } else {
            this.failToLoadConnectionHist();
          }
        })
        .catch(() => {
          this.failToLoadConnectionHist();
        })
        .finally(() => {
          this.loading.connect = false;
        });
    },
    /**
     * 접속 이력 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadConnectionHist() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '접속 이력', false));
    },
    /**
     * 계정 전환 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadAccountSwitchData() {
      const commonParams = this.getCommonParams();
      const tableParams = this.$refs.accountTable.getParameter();
      const params = {
        ...commonParams,
        ...tableParams,
      };
      this.loading.account = true;
      serverTableInfoAPI
        .getAccountSwitchingList(params)
        .then((response) => {
          if (response.data.success === true) {
            this.tableData.account = response.data.data;
            this.total.account = response.data.total;
            this.checkDatetime = this.baseDatetime;
          } else {
            this.failToLoadAccountSwitch();
          }
        })
        .catch(() => {
          this.failToLoadAccountSwitch();
        })
        .finally(() => {
          this.loading.account = false;
        });
    },
    /**
     * 계정 전환 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadAccountSwitch() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정 전환 정보', false));
    },
    /**
     * 암호 변경 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadPasswordChangeData() {
      const commonParams = this.getCommonParams();
      const tableParams = this.$refs.passwordTable.getParameter();
      const params = {
        ...commonParams,
        ...tableParams,
      };
      this.loading.password = true;
      serverTableInfoAPI
        .getLogChngpasswdHistList(params)
        .then((response) => {
          if (response.data.success === true) {
            this.tableData.password = response.data.data;
            this.total.password = response.data.total;
            this.checkDatetime = this.baseDatetime;
          } else {
            this.failToLoadPasswordChange();
          }
        })
        .catch(() => {
          this.failToLoadPasswordChange();
        })
        .finally(() => {
          this.loading.password = false;
        });
    },
    /**
     * 암호 변경 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadPasswordChange() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '암호 변경 정보', false));
    },
    /**
     * 암호 변경 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadPortCtrlData() {
      const commonParams = this.getCommonParams();
      const tableParams = this.$refs.portCtrlTable.getParameter();
      const params = {
        ...commonParams,
        ...tableParams,
      };
      this.loading.portCtrl = true;
      serverTableInfoAPI
        .getSmsLogPortctrlHistList(params)
        .then((response) => {
          if (response.data.success === true) {
            this.tableData.portCtrl = response.data.data;
            this.total.portCtrl = response.data.total;
            this.checkDatetime = this.baseDatetime;
          } else {
            this.failToLoadPortCtrl();
          }
        })
        .catch(() => {
          this.failToLoadPortCtrl();
        })
        .finally(() => {
          this.loading.portCtrl = false;
        });
    },
    /**
     * 암호 변경 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadPortCtrl() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '차단 이력', false));
    },
    // loadFileAccesssData() {
    //   serverTableInfoAPI.getFileAccessList(params).then((response) => {
    //     if (response.data.success === true) {
    //     }
    //   });
    // },
    /**
     * 공통 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParams() {
      this.baseDatetime = this.timeType === analysisTimeType.CURRENT.value || this.operationFlag ? new Date().getTime() : this.plotLineDatetime;

      // '시스템 접근' 탭의 데이터들은 이벤트 타임 라인에 선택한 시간대 가 아닌, DatetimeRangeButton 공통 컴포넌트에 설정된 시간 범위로 조회하기로 정책 변경.
      // 관련 일감 : http://idc.watchtek.co.kr:8188/redmine/issues/54023
      const params = {
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
      };

      params.objId = this.selectedNode.obj.objId;
      return params;
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onDataTypeChange() {
      this.loadData();
    },
    /**
     * [년월일 시간 설정]
     * @author {Yang}
     * @param  {[long]} 시간
     * @return {[String]} ex) 2000-01-01 12:12:12
     */
    getTime(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    /**
     * [시간단위만 설정]
     * @author {Yang}
     * @param  {[long]} 시간
     * @return {[String]} ex) 12:12:12
     */
    getDuration(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : getDuration(value * 1000);
    },
    /**
     * [성공 여부 설정]
     * @author {Yang}
     * @param  {[boolean]}
     * @return {[String]} ex) 성공/실패
     */
    getSuccess(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return value === 'FF' ? '실패' : '성공';
    },
    onShowSearchToolButtonClick() {
      if (this.dataType === this.dataTypeData.connect) {
        this.showSearchTool.connect = !this.showSearchTool.connect;
      } else if (this.dataType === this.dataTypeData.account) {
        this.showSearchTool.account = !this.showSearchTool.account;
      } else if (this.dataType === this.dataTypeData.password) {
        this.showSearchTool.password = !this.showSearchTool.password;
      } else if (this.dataType === this.dataTypeData.portCtrl) {
        this.showSearchTool.portCtrl = !this.showSearchTool.portCtrl;
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    // formatterFileType(row) {
    //   switch (row.accessType) {
    //     case 'OP':
    //       return '파일접근';
    //     case 'CP':
    //       return '파일복사';
    //     case 'RM':
    //       return '파일삭제';
    //     case 'MV':
    //       return '파일이동';
    //     default:
    //       return EMPTY_TEXT;
    //   }
    // },
    // formatterFileEmpty(row, col) {
    //   if (isNil(row[col])) {
    //     return EMPTY_TEXT;
    //   }
    //   return row[col];
    // },
    // formatterFileSrc(row) {
    //   return this.formatterFileEmpty(row, 'srcFile');
    // },
    // formatterFileDst(row) {
    //   return this.formatterFileEmpty(row, 'dstFile');
    // },
    // formatterFileDir(row) {
    //   return this.formatterFileEmpty(row, 'fileDir');
    // },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/components/table/SystemAccessInfoTable.vue